import { FC } from 'react'
import styled from 'styled-components'
import { ImageAsset, TextLegacy } from '@/components/common'
import { NewButtonToHome } from '@/components/common/buttons/new/NewButtonToHome'
import { FIXED_HEIGHT } from '@/constants/legacy/constLayout'
import { ListOrderType } from '@/constants/legacy/constType'

type ListOrderEmptyProps = {
  type: ListOrderType
}

const ListOrderEmpty: FC<ListOrderEmptyProps> = ({ type }) => {
  const getEmptyComments = () => {
    switch (type) {
      case 'order':
        return `주문내역이 없습니다.\n지금 바로 첫 구매를 시작해 보세요.`
      case 'cancel-return-exchange':
        return `취소/반품/교환 내역이 없습니다.`
      default:
        return null
    }
  }

  const getEmptyGoToLinkBtn = () => {
    switch (type) {
      case 'order':
        return <NewButtonToHome />
      default:
        return null
    }
  }

  return (
    <StyledOuter headerHeight={FIXED_HEIGHT.HEADER}>
      <StyledInner>
        <StyledRow>
          <ImageAsset name="no_list" size={80} />
        </StyledRow>
        <StyledRow style={{ marginTop: 15 }}>
          <TextLegacy color="gray400" align="center">
            {getEmptyComments()}
          </TextLegacy>
        </StyledRow>
        <StyledButtonWrapper>{getEmptyGoToLinkBtn()}</StyledButtonWrapper>
      </StyledInner>
    </StyledOuter>
  )
}

const StyledOuter = styled.div<{ headerHeight: number }>`
  display: flex;
  height: ${(props) => `calc(100vh - ${props.headerHeight}px - 150px)`};
  margin: -16px;
`
const StyledInner = styled.div`
  margin: auto;
`

const StyledRow = styled.div`
  text-align: center;
`

const StyledButtonWrapper = styled.div`
  margin-top: 1.6rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export default ListOrderEmpty
